module.exports = __webpack_public_path__ + "static/media/orange.a125661f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/poly/orange.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/poly/orange.jpeg
// module chunks = 0